/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { sectionRemoveSection } from '../fn/section/section-remove-section';
import { SectionRemoveSection$Params } from '../fn/section/section-remove-section';
import { sectionReorderSections } from '../fn/section/section-reorder-sections';
import { SectionReorderSections$Params } from '../fn/section/section-reorder-sections';
import { sectionSetSection } from '../fn/section/section-set-section';
import { SectionSetSection$Params } from '../fn/section/section-set-section';

@Injectable({ providedIn: 'root' })
export class SectionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sectionReorderSections()` */
  static readonly SectionReorderSectionsPath = '/api/Section/{sectionId}/reorder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sectionReorderSections()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sectionReorderSections$Response(params: SectionReorderSections$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sectionReorderSections(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sectionReorderSections$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sectionReorderSections(params: SectionReorderSections$Params, context?: HttpContext): Observable<void> {
    return this.sectionReorderSections$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sectionSetSection()` */
  static readonly SectionSetSectionPath = '/api/Section/set';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sectionSetSection()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sectionSetSection$Response(params?: SectionSetSection$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sectionSetSection(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sectionSetSection$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sectionSetSection(params?: SectionSetSection$Params, context?: HttpContext): Observable<void> {
    return this.sectionSetSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sectionRemoveSection()` */
  static readonly SectionRemoveSectionPath = '/api/Section/remove/{sectionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sectionRemoveSection()` instead.
   *
   * This method doesn't expect any request body.
   */
  sectionRemoveSection$Response(params: SectionRemoveSection$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sectionRemoveSection(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sectionRemoveSection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sectionRemoveSection(params: SectionRemoveSection$Params, context?: HttpContext): Observable<void> {
    return this.sectionRemoveSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
